// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 3 ? "build-glob" : chunkId) + "-legacy." + {"3":"16521367","34":"7def9950","147":"d5ec3eff","162":"c4446ad4","243":"2729f373","395":"1b302ccf"}[chunkId] + ".js";
};